module.exports = __webpack_public_path__ + "static/img/home_part1@2x.2d4a6fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_part1@2x.jpg
// module id = iSyH
// module chunks = 0